<template>
  <div>
    <form class="mt-4 px-2"
          name="formCartorioServentia"
          novalidate>
      <div class="row">
        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="cns">CNS</label>
            <input id="cns"
                   v-model="dadosCartorio.cns"
                   class="form-control form-control-sm"
                   disabled
                   name="cns"
                   type="text"
                   @change="emitChange()">
          </div>
        </div>

        <div class="col-12 col-sm-4">
          <div class="form-group">
            <label class="label"
                   for="nome">Nome</label>
            <input id="nome"
                   v-model="dadosCartorio.nome"
                   class="form-control form-control-sm"
                   name="nome"
                   disabled
                   placeholder="Ex: José Dantas"
                   type="text"
                   @change="emitChange()">
          </div>
        </div>

        <div class="col-12 col-sm-2">
          <div class="form-group">
            <label class="label"
                   for="cei">CEI</label>
            <input id="cei"
                   v-model="dadosCartorio.cei"
                   class="form-control form-control-sm"
                   name="cei"
                   type="text"
                   @change="emitChange()">
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="seade">Seade</label>
            <input id="seade"
                   v-model="dadosCartorio.seade"
                   v-validate="'required'"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.has('seade') }"
                   name="seade"
                   required
                   type="text"
                   @change="emitChange()">
            <small v-if="errors.has('seade')"
                   class="invalid-feedback">{{ errors.first('seade') }}</small>
          </div>
        </div>
        <div class="col-12 col-sm-5 col-lg-3">
          <div class="form-group">
            <label class="label"
                   for="nome">Comarca</label>
            <input id="comarca"
                   v-model="dadosCartorio.comarca"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.has('comarca') }"
                   name="comarca"
                   type="text"
                   @change="emitChange()">
            <small v-if="errors.has('comarca')"
                   class="invalid-feedback">{{ errors.first('comarca') }}</small>
          </div>
        </div>

        <div class="col-12 col-sm-5 col-lg-3">
          <div class="form-group">
            <label class="label"
                   for="nome">CNPJ</label>
            <input id="cnpj"
                   v-model="dadosCartorio.cnpj"
                   v-validate:cnpj="{ required: !semCnjp, min: 14 }"
                   v-mask="`##.###.###/####-##`"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.has('cnpj') }"
                   :disabled="semCnjp"
                   name="cnpj"
                   placeholder="00.000.000/0000-00"
                   type="text"
                   @change="emitChange()">
            <small v-if="errors.has('cnpj')"
                   class="invalid-feedback">{{ errors.first('cnpj') }}</small>
          </div>
        </div>

        <div class="col-auto">
          <div class="form-group">
            <span class="custom-control custom-checkbox custom-inline">
              <input id="semCnpj"
                     v-model="semCnjp"
                     class="custom-control-input"
                     name="semCnpj"
                     type="checkbox"
                     @change="changeCnpj">
              <label class="custom-control-label"
                     for="semCnpj">Não possui CNPJ</label>
            </span>
          </div>
        </div>
      </div>
    </form>

    <BoxEndereco :data="dadosCartorio.endereco"
                 :prop-localizacao="true"
                 @onEnderecoAdd="getAdress" />

    <form class="my-4"
          name="formOutrasInfo"
          novalidate>
      <h3 class="title--divisor">
        Outras informações
      </h3>

      <div class="p-2">
        <div class="row">
          <div class="col-12 col-sm-3">
            <div class="form-group">
              <label class="label"
                     for="emailCartorio">E-mail</label>
              <input id="emailCartorio"
                     v-model="dadosCartorio.email"
                     v-validate="'required|email'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('emailCartorio') }"
                     name="emailCartorio"
                     placeholder="Ex: jose.dantas@gmail.com"
                     required
                     type="email"
                     @change="emitChange()">
              <small v-if="errors.has('emailCartorio')"
                     class="invalid-feedback">{{ errors.first('emailCartorio') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-3">
            <div class="form-group">
              <label class="label"
                     for="telefoneCartorio">Telefone</label>
              <input id="telefoneCartorio"
                     v-model="dadosCartorio.telefone"
                     v-validate:telefoneCartorio="{ required: true, min: 8 }"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('telefoneCartorio') }"
                     name="telefoneCartorio"
                     placeholder="(11) 94891-1518"
                     type="text"
                     @change="emitChange()">
              <small v-if="errors.has('telefoneCartorio')"
                     class="invalid-feedback">{{ errors.first('telefoneCartorio') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-3">
            <div class="form-group">
              <label class="label"
                     for="inicioCartorio">Data ínicio do cartório</label>
              <input id="inicioCartorio"
                     v-model="dadosCartorio.inicio_cartorio"
                     v-validate="`required|date_format:yyyy-MM-dd|max_date:${new Date()}`"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('inicioCartorio') }"
                     name="inicioCartorio"
                     type="date"
                     @change="emitChange()">
              <small v-if="errors.has('inicioCartorio')"
                     class="invalid-feedback">{{ errors.first('inicioCartorio') }}</small>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label class="label"
                     for="simOficio">Primeiro Oficio ?</label>
              <div class="d-block">
                <span class="custom-control custom-radio custom-control-inline">
                  <input id="simOficio"
                         v-model="dadosCartorio.primeiro_oficio"
                         type="radio"
                         :value="1"
                         name="primeiroOficio"
                         class="custom-control-input"
                         @change="emitChange()">
                  <label class="custom-control-label"
                         for="simOficio">Sim</label>
                </span>

                <span class="custom-control custom-radio custom-control-inline">
                  <input id="naoOficio"
                         v-model="dadosCartorio.primeiro_oficio"
                         type="radio"
                         :value="0"
                         name="primeiroOficio"
                         class="custom-control-input"
                         @change="emitChange()">
                  <label class="custom-control-label"
                         for="naoOficio">Não</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form class="my-4"
          name="formOficial"
          novalidate>
      <h3 class="title--divisor">
        Oficial
      </h3>

      <div class="px-2">
        <div class="row mt-4">
          <div class="col-12 col-sm-5">
            <div class="form-group">
              <label class="label"
                     for="nomeOficial">Nome</label>
              <input id="nomeOficial"
                     v-model="dadosCartorio.nome_oficial"
                     v-validate="'required'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('nomeOficial') }"
                     name="nomeOficial"
                     placeholder="Ex: José Gumercindo"
                     type="text"
                     @change="emitChange()">
              <small v-if="errors.has('nomeOficial')"
                     class="invalid-feedback">{{ errors.first('nomeOficial') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-4 col-lg-3">
            <div class="form-group">
              <label class="label"
                     for="cpfOficial">CPF</label>
              <input id="cpfOficial"
                     v-model="dadosCartorio.cpf_oficial"
                     v-validate:cpfOficial="{ required: true, min: 11 }"
                     v-mask="`999.999.999-99`"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('cpfOficial') }"
                     maxlength="14"
                     name="cpfOficial"
                     placeholder="000.000.000-00"
                     type="text"
                     @change="emitChange()">
              <small v-if="errors.has('cpfOficial')"
                     class="invalid-feedback">{{ errors.first('cpfOficial') }}</small>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form class="my-4"
          name="formOficial"
          novalidate>
      <h3 class="title--divisor">
        Guia de Recolhimento
      </h3>

      <div class="px-2">
        <div class="row mt-4">
          <div class="col-12 col-sm-5">
            <div class="form-group">
              <label class="label"
                     for="numeroAtual">Número Atual</label>
              <input id="numeroAtual"
                     v-model="dadosCartorio.guia_numero_atual"
                     v-validate="'required'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('numeroAtual') }"
                     name="numeroAtual"
                     placeholder=""
                     type="text"
                     disabled
                     @change="emitChange()">
              <small v-if="errors.has('numeroAtual')"
                     class="invalid-feedback">{{ errors.first('numeroAtual') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-4 col-lg-3">
            <div class="form-group">
              <label class="label"
                     for="anoAtual">Ano Atual</label>
              <input id="anoAtual"
                     v-model="dadosCartorio.guia_ano_atual"
                     v-validate="'required'"
                     v-mask="`####`"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('anoAtual') }"
                     name="anoAtual"
                     type="text"
                     disabled
                     @change="emitChange()">
              <small v-if="errors.has('anoAtual')"
                     class="invalid-feedback">{{ errors.first('anoAtual') }}</small>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form class="my-4"
          name="formOficial"
          novalidate>
      <h3 class="title--divisor">
        Ativação de Módulos
      </h3>
      <ModulosServentia />
    </form>
    <form class="mt-4"
          name="formIssqn"
          novalidate>
      <h3 class="title--divisor">
        ISSQN
      </h3>

      <div class="px-2">
        <div class="row mt-4">
          <div class="col-auto">
            <div class="form-group">
              <label class="label"
                     for="simEndereco">Tem Tributação ?</label>
              <div class="d-block">
                <span class="custom-control custom-radio custom-control-inline">
                  <input id="naoEndereco"
                         v-model="dadosCartorio.issqn"
                         type="radio"
                         :value="0"
                         name="tributacaoIssqn"
                         class="custom-control-input"
                         @change="changeTributacao">
                  <label class="custom-control-label"
                         for="naoEndereco">Não</label>
                </span>

                <span class="custom-control custom-radio custom-control-inline">
                  <input id="simEndereco"
                         v-model="dadosCartorio.issqn"
                         type="radio"
                         :value="1"
                         name="tributacaoIssqn"
                         class="custom-control-input"
                         @change="changeTributacao">
                  <label class="custom-control-label"
                         for="simEndereco">Sim</label>
                </span>
              </div>
            </div>
          </div>

          <div class="col-auto">
            <div class="form-group">
              <label class="label"
                     for="aliquota">Alíquota para seu município</label>
              <input id="aliquota"
                     v-model="dadosCartorio.aliquota_issqn"
                     v-validate="{ required: !(dadosCartorio.issqn && (dadosCartorio.issqn === 0))}"
                     v-mask="`#.##%`"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('aliquota') }"
                     :disabled="(dadosCartorio.issqn && (dadosCartorio.issqn === 0))"
                     maxlength="5"
                     max="9.99"
                     min="0.01"
                     name="aliquota"
                     placeholder="Ex: 9,00%"
                     type="text"
                     @change="emitChange()">
              <small v-if="errors.has('aliquota')"
                     class="invalid-feedback">{{ errors.first('aliquota') }}</small>
            </div>
          </div>

          <div class="col-auto">
            <div class="form-group">
              <label class="label"
                     for="calculoIssqn">ISSQN Calculado sobre</label>
              <select id="calculoIssqn"
                      v-model="dadosCartorio.tipo_calculo_issqn"
                      v-validate="{ required: !(dadosCartorio.issqn && (dadosCartorio.issqn === 0))}"
                      class="custom-select custom-select-sm"
                      :class="{ 'is-invalid': errors.has('calculoIssqn') }"
                      :disabled="(dadosCartorio.issqn && (dadosCartorio.issqn === 0))"
                      name="calculoIssqn"
                      type="text"
                      @change="emitChange()">
                <option :value="`LIQUIDO`">
                  Líquido
                </option>
                <option :value="`BRUTO`">
                  Bruto
                </option>
              </select>
              <small v-if="errors.has('calculoIssqn')"
                     class="invalid-feedback">{{ errors.first('calculoIssqn') }}</small>
            </div>
          </div>
          <div class="col-auto">
            <div class="form-group">
              <label for="calculo_notas">Cálculo sobre notas</label>
              <div class="row ml-1">
                <b-form-radio v-model="dadosCartorio.tipo_calculo_iss_notas"
                              name="some-radios"
                              value="TABELIAO"
                              class="mr-4"
                              @change="emitChange()">
                  Tabelião
                </b-form-radio>
                <b-form-radio v-model="dadosCartorio.tipo_calculo_iss_notas"
                              name="some-radios"
                              value="TABELIAO_MP"
                              @change="emitChange()">
                  Tabelião + MP
                </b-form-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form class="my-4"
          name="formTJ"
          novalidate>
      <h3 class="title--divisor">
        Chaves Tribunal de Justiça
      </h3>

      <div class="px-2">
        <div class="row mt-4">
          <div class="col-12 col-sm-5">
            <div class="form-group">
              <label class="label"
                     for="chave-acesso">Chave de acesso</label>
              <input id="chave-acesso"
                     v-model="chaves.chave_acesso"
                     class="form-control form-control-sm"
                     name="chave-acesso"
                     placeholder=""
                     type="password"
                     @change="emitChange()">
              <svg v-if="!errors.has('chave-acesso')"
                   id="eye_acesso"
                   class="icon--sm eye_acesso"
                   role="presentation"
                   @mouseup="returnPass('acesso')"
                   @mousedown="showPass('acesso')"
                   @mouseleave="returnPass('acesso')">
                <use :xlink:href="'#' + eyeGray.id" />
              </svg>
              <small v-if="errors.has('chave-acesso')"
                     class="invalid-feedback">{{ errors.first('chave-acesso') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-4 col-lg-3">
            <div class="form-group">
              <label class="label"
                     for="chave-seguranca">Chave de segurança</label>
              <input id="chave-seguranca"
                     v-model="chaves.chave_seguranca"
                     class="form-control form-control-sm"
                     name="chave-seguranca"
                     type="password"
                     @change="emitChange()">
              <svg v-if="!errors.has('chave-seguranca')"
                   id="eye_seguranca"
                   class="icon--sm eye_seguranca"
                   role="presentation"
                   @mouseup="returnPass('seguranca')"
                   @mousedown="showPass('seguranca')"
                   @mouseleave="returnPass('seguranca')">
                <use :xlink:href="'#' + eyeGray.id" />
              </svg>
              <small v-if="errors.has('chave-seguranca')"
                     class="invalid-feedback">{{ errors.first('chave-seguranca') }}</small>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form class="my-4"
          name="formEProtocolo"
          novalidate>
      <h3 class="title--divisor">
        Chave de integração - e-Protocolo
      </h3>

      <div class="px-2">
        <div class="row mt-4">
          <div class="col-12 col-sm-5">
            <div class="form-group">
              <label class="label"
                     for="usuario">Usuário</label>
              <input id="usuario"
                     v-model="eProtocolo.usuario"
                     class="form-control form-control-sm"
                     name="usuario"
                     placeholder=""
                     type="text"
                     @change="emitChange()">
              <small v-if="errors.has('usuario')"
                     class="invalid-feedback">{{ errors.first('usuario') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-4 col-lg-3">
            <div class="form-group">
              <label class="label"
                     for="senha">Senha</label>
              <input id="senha"
                     v-model="eProtocolo.senha"
                     class="form-control form-control-sm"
                     name="senha"
                     type="password"
                     @change="emitChange()">
              <svg v-if="!errors.has('senha')"
                   id="eye_seguranca"
                   class="icon--sm eye_seguranca"
                   role="presentation"
                   @mouseup="returnPass('senha')"
                   @mousedown="showPass('senha')"
                   @mouseleave="returnPass('senha')">
                <use :xlink:href="'#' + eyeGray.id" />
              </svg>
              <small v-if="errors.has('senha')"
                     class="invalid-feedback">{{ errors.first('senha') }}</small>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div v-if="!propWizard"
         class="d-flex justify-content-end">
      <div class="d-inline-block mb-2">
        <button class="btn btn-sm btn-primary"
                type="button"
                @click="updateCartorio">
          Atualizar dados
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import BoxEndereco from '@/components/SofiaRei/BoxEndereco.vue'
  import CartorioService from "@/services/CartorioService"
  import { filterMaskedNumber } from "@/filters/filters"
  import { showAPIValidatorErrors } from '@/utils/showAPIErrors'
  import { mapGetters } from 'vuex'
  import objSwal from '@/constants/swalValues'
  import Swal from 'sweetalert2'
  import moment from 'moment'
  import eyeGray from "@/assets/icons/eye-gray.svg?sprite"
  import ModulosServentia from './ModulosServentia.vue'

  export default {
    name: 'CartorioServentia',
    components: { BoxEndereco, ModulosServentia },
    props: {
      tabActive: Number,
      propWizard: {type: Boolean, default: false}
    },
    inject: ['$validator'],
    data () {
      return {
        semCnjp: false,
        dadosCartorio: {
          primeiro_oficio: 0
        },
        chaves: {
          chave_acesso: null,
          chave_seguranca: null
        },
        eyeGray,
        eProtocolo: {
          usuario: null,
          senha: null
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
      }),
      cnpj () {
        let value = this.dadosCartorio.cnpj || ''

        return filterMaskedNumber(value)
      },
      telefoneCartorio () {
        let value = this.dadosCartorio.telefone || ''

        return filterMaskedNumber(value)
      },
      cpfOficial () {
        let value = this.dadosCartorio.cpf_oficial || ''

        return filterMaskedNumber(value)
      },
    },
    watch: {
      dadosCartorio () {
        if (this.propWizard) this.$emit('changed', this.dadosCartorio)
      },
      'chaves.chave_acesso': function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('changed', { ...this.dadosCartorio, ...this.chaves })
        }
      },
      'chaves.chave_seguranca': function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('changed', { ...this.dadosCartorio, ...this.chaves })
        }
      }
    },
    beforeMount () {
      CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id).then(res => {
        this.dadosCartorio = res.data ? res.data : {}
        let { primeiro_oficio, issqn, tipo_calculo_issqn, inicio_cartorio, aliquota_issqn, comarca } = this.dadosCartorio

        this.dadosCartorio.primeiro_oficio = parseInt(primeiro_oficio) || 0
        this.dadosCartorio.aliquota_issqn =  (parseInt(aliquota_issqn)) ? parseInt(aliquota_issqn).toFixed(2) : '00.00',

        this.dadosCartorio.issqn = parseInt(issqn) || 0
        this.dadosCartorio.tipo_calculo_issqn = tipo_calculo_issqn || 'LIQUIDO'

        this.dadosCartorio.comarca = comarca || this.dadosCartorio.endereco.cidade

        if (inicio_cartorio) {
          this.dadosCartorio.inicio_cartorio = moment(inicio_cartorio).format('YYYY-MM-DD')
        }
      })

      const params = {
        cartorio_id: this.$store.state.auth.cartorio_id
      }

      CartorioService.getChavesTJ(params).then(res => {
        this.chaves.chave_acesso = res.data.chaveAcesso.valor
        this.chaves.chave_seguranca = res.data.chaveSeguranca.valor
      })

      CartorioService.getChavesEProtocolo(params).then(res => {
        this.eProtocolo.usuario = res.data.chaveAcesso.valor
        this.eProtocolo.senha = res.data.chaveSeguranca.valor
      })

      if (this.propWizard) this.$emit('changed', this.dadosCartorio)
    },
    methods: {
      updateCartorio () {
        this.$validator.validate().then(async resp => {
          if (resp) {
            let dados = {
              ...this.dadosCartorio,
              aliquota_issqn: this.dadosCartorio.aliquota_issqn ? this.dadosCartorio.aliquota_issqn.replace(('%' || '.'), '') : '00.00',
              cnpj: this.dadosCartorio.cnpj ? this.dadosCartorio.cnpj.replace(/\D/g, "") : null,
              cpf_oficial: this.dadosCartorio.cpf_oficial ? this.dadosCartorio.cpf_oficial.replace(('.' || '-'), '') : null,
              nomeOficial: this.dadosCartorio.nome_oficial,
              tipo_calculo_issqn: !this.dadosCartorio.tipo_calculo_issqn ? '' : this.dadosCartorio.tipo_calculo_issqn,
              chave_acesso: this.chaves.chave_acesso,
              chave_seguranca: this.chaves.chave_seguranca,
              eProtocolo_usuario: this.eProtocolo.usuario,
              eProtocolo_senha: this.eProtocolo.senha
            }

            dados.endereco.codigo_pais = '76'

            if (!dados.endereco.complemento) {
              dados.endereco.complemento = ''
            }

            delete dados.created_at
            delete dados.updated_at

            CartorioService.updateCartorioRei(dados).then(res => {
              objSwal.success.title = 'Dados atualizados'
              objSwal.success.text = ''

              Swal.fire(objSwal.success).then(turnAround => turnAround)
            }).catch(({ response: { data } }) => {
              const message = getErrors(data)

              return displayMessage('error', 'Erro!', message.message)
            })
          } else {

            objSwal.error.title = 'Campos não preenchidos'
            objSwal.error.text = 'Por favor, verifique o formulário e preencha os campos solicitados.'

            Swal.fire(objSwal.error).then(turnAround => turnAround)
          }
        })
      },
      changeCnpj () {
        this.emitChange()

        return ((this.semCnjp && this.dadosCartorio.cnpj) ? this.dadosCartorio.cnpj = '' : null)
      },
      getAdress (val) {
        this.dadosCartorio.endereco = { ...val }

        this.emitChange()
      },
      changeTributacao () {
        if ((this.dadosCartorio.issqn !== 1)) {
          this.dadosCartorio.tipo_calculo_issqn = null
          this.dadosCartorio.aliquota_issqn = '00.00'
        }

        this.emitChange()
      },
      emitChange () {
        const dados = { ...this.dadosCartorio, ...this.chaves}

        this.$emit('changed', dados)
      },
      returnPass (type, obj) {
        var obj = document.getElementById(type === 'senha' ? 'senha' : `chave-${type}`)
        obj.type = "password"
      },
      showPass (type,obj) {
        var obj = document.getElementById(type === 'senha' ? 'senha' : `chave-${type}`)
        obj.type = "text"
      },
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/_exports';

  .title {
    &--divisor {
      background-color: $color-gray-light;
      color: $color-dark;
      font-size: pxToRem(16);
      font-weight: 500;
      margin-top: pxToRem(-14);
      padding: pxToRem(10) pxToRem(20);
    }
  }

  .eye {
        &_acesso {
         cursor: pointer;
         left: 92%;
         position: relative;
         top:-28px;
        }

        &_seguranca {
         cursor: pointer;
         left: 88%;
         position: relative;
         top:-28px;
        }
     }
</style>
